<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item
              :to="{
                name: 'DashboardHome',
              }"
            >
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              新東陽 會員資料修改
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">新東陽 會員資料修改</h4>
        </div>
      </div>

      <b-overlay
        :show="isLoading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
      >
        <editor
          class="mb-2 mr-sm-2 mb-sm-0"
          v-model="modifyAccountInfo"
          width="100%"
          height="200px"
          @init="editorInit"
          lang="json"
          theme="chrome"
          :disabled="!editable"
        >
        </editor>

        <div class="mb-3">
          <b-button variant="success" @click="handleCreate">
            會員資料修改
          </b-button>
        </div>

        <editor
          class="mb-2 mr-sm-2 mb-sm-0"
          v-if="result"
          v-model="result"
          width="100%"
          height="300px"
          @init="editorInit"
          lang="json"
          theme="chrome"
          :disabled="1"
        >
        </editor>
      </b-overlay>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.group + .group {
  border-top: 1px solid #cdd6dc !important;
}
</style>
<script>
import { mapState } from "vuex";
import useVuelidate from "@vuelidate/core";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import editor from "vue2-ace-editor";
import fileMixin from "@/mixins/uploadFile";
import htyApi from "@/apis/hty"
import {required} from "@vuelidate/validators";


export default {
  mixins: [fileMixin],
  components: { editor },
  validationConfig: {
    $lazy: true,
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      phone: {
        required
      },
    };
  },
  data() {
    /*
     *  由於欄位是個動態 array ，因此 vuelidate 幾乎觸發不了驗證
     * ，因此編輯時暫時將
     *  forms = [{key: 'k', value: 'v'}]
     *  轉為form = {k:v}
     *  最後 submit 再轉換回來
     */
    return {
      code: null,
      phone: null,
      result: "",
      color: "",
      isLoading: false,
      isSubmitting: false,
      formGroups: {},
      module: {},
      fetchedVariableId: null,
      canEdit: false,
      modifyAccountInfo: `{
        "C_NO": "",
        "Name": "",
        "Mobile": "",
        "BIRTH": "",
        "Gender": "",
        "Passwd": "",
        "VerifyCode": "",
        "RES_S_NO": ""
      }`,
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    orgId() {
      return this.organization.id;
    },
    editable() {
      return !this.isShownByVariableCode || this.canEdit
    },
  },
  mounted() {
    if (!this.checkPermission([consts.HTY_LMS_SETTING_QUERY])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33",
        })
        .then(() => {
          this.$router.push({
            name: "OrganizationVariableList",
          });
        });
    }

  },
  methods: {
    editorInit() {
      require("brace/ext/language_tools"); //language extension prerequsite...
      require("brace/mode/json");
      require("brace/mode/html");
      require("brace/theme/chrome");
    },

    async handleCreate() {
      let params = JSON.parse(this.modifyAccountInfo);
      let response = await htyApi.modifyAccount(params);
      this.result = JSON.stringify(response.data, null, 2);
      if (response.data.error) {
        this.$swal.fire({
          type: "error",
          text: response.data.error || "修改失敗，請稍後再試",
          confirmButtonColor: "#d33",
        });
        return;
      }
      this.showSuccessPopup(false);
    },

    showSuccessPopup(redirect = true) {
      this.$swal
        .fire({
          type: "success",
          text: "修改成功",
        })
        .then(() => {
          if (redirect) {
            this.$router.push({
              name: this.isByMerchant
                ? "OrganizationVariableListByMerchant"
                : "OrganizationVariableList",
            });
          }
        });
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
  },
};
</script>
